module.exports = __webpack_public_path__ + "img/a6.a55a241f.png";